import Hash from './Hash.js';


class ApiService {

    static STATUS_OK = "statusOk";
    static STATUS_ERROR = "statusError";
    static deviceId = 'NOT_DETECTED';
    static isAuthorized = false;

    // static API_URL = "http://localhost:86/apiv1.php";

    //////////////// FOR DEPLOY ////////////////////////////
    static API_URL = "/admin_rk/server/apiv1.php";
    static USERID = null;
    //////////////// FOR DEPLOY ////////////////////////////


    //////////////// FOR DEBUG ////////////////////////////
    //static API_URL = "https://rk.geosamara.ru/admin_rk/server/apiv1.php";
    //static USERID = 1;
    //////////////// FOR DEBUG ////////////////////////////


    static API_CLIENT_ID = "test";
    static API_SECRET = "test";

    static async userinfo() {
        return this.request('userinfo');
    }

    static async getObjects(database, table, filter = null, projection = null, limit = null, skip = null, sortBy = null, sortOrder = null) {
        let message = { database: database, table: table };
        if (filter) {
            message["filter"] = filter;
        }
        if (projection) {
            message["projection"] = projection;
        }
        if (limit) {
            message["limit"] = limit;
        }
        if (skip) {
            message["skip"] = skip;
        }
        if (sortBy) {
            message["sortBy"] = sortBy;
        }
        if (sortOrder) {
            message["sortOrder"] = sortOrder;
        }
        return this.request('getObjects', message);
    }

    static async updateObject(database, table, object, partial = null) {
        let message = { database: database, table: table, object: object };
        if (partial) {
            message["partial"] = partial;
        }
        return this.request('updateObject', message);
    }

    static async updateManyObjects(database, table, filter, set) {
        let message = { database: database, table: table, filter: filter, set: set };
        return this.request('updateManyObjects', message);
    }

    static async findCluster(database, value, fullInfo = false) {
        let message = { database: database, value: value, fullInfo: fullInfo };
        return this.request('findCluster', message);
    }

    static async getConnections(database, source, id) {
        let message = { database: database, source: source, id: id };
        return this.request('getConnections', message);
    }

    static async RatioOfFullClustersByBlocks(database, sources) {
        let message = { database: database, sources: sources };
        return this.request('RatioOfFullClustersByBlocks', message);
    }

    static async RepeatedIDNumberByBlocks(database, sources) {
        let message = { database: database, sources: sources };
        return this.request('RepeatedIDNumberByBlocks', message);
    }

    static async AvgWeightForSourceByBlocks(database, sources) {
        let message = { database: database, sources: sources };
        return this.request('AvgWeightForSourceByBlocks', message);
    }

    static async LinkedObjCountByBlocks(database, sources) {
        let message = { database: database, sources: sources };
        return this.request('LinkedObjCountByBlocks', message);
    }

    static async GetSourceStatistics(database, source) {
        let message = { database: database, source: source };
        return this.request('GetSourceStatistics', message);
    }

    static async GetUniqueValues(database, source, level) {
        let message = { database: database, source: source, level: level };
        return this.request('GetUniqueValues', message);
    }

    static async GetStatisticsForSourcesPair(database, sources, level, block) {
        let message = { database: database, sources: sources, level: level, block: block };
        return this.request('GetStatisticsForSourcesPair', message);
    }
    static async GetWeightHistForSourcePair(database, source1, source2, level, block) {
        let message = { database: database, source1: source1, source2: source2, level: level, block: block };
        return this.request('GetWeightHistForSourcePair', message);
    }
    static async GetAvgLinkNumberPerIDPair(database, source1, source2, level, block) {
        let message = { database: database, source1: source1, source2: source2, level: level, block: block };
        return this.request('GetAvgLinkNumberPerIDPair', message);
    }
    static async GetComparativeTable(database, source1, source2, level, block, mode, N = null, weight = null) {
        let message = { database: database, source1: source1, source2: source2, level: level, block: block, mode: mode };
        if (N) {
            message["N"] = N;
        }
        if (weight || 0) {
            message["weight"] = weight;
        }
        return this.request('GetComparativeTable', message);
    }
    static async GetSrcRatioByWeight(database, sources, block, weight = null) {
        let message = { database: database, sources: sources, block: block };
        if (weight || 0) {
            message["weight"] = weight;
        }
        return this.request('GetSrcRatioByWeight', message);
    }
    static async GetClusterHistograms(database, sources, block) {
        let message = { database: database, sources: sources, block: block };
        return this.request('GetClusterHistograms', message);
    }
    static async CountOfNotLinkedObjectsInSource(database, sources, block) {
        let message = { database: database, sources: sources, block: block };
        return this.request('CountOfNotLinkedObjectsInSource', message);
    }
    static async PairwiseStatisticsForUnlinkedObjs(database, sources, block) {
        let message = { database: database, sources: sources, block: block };
        return this.request('PairwiseStatisticsForUnlinkedObjs', message);
    }
    static async GetHistForPairwiseLinksOutOfCluster(database, source1, source2, block) {
        let message = { database: database, source1: source1, source2: source2, block: block };
        return this.request('GetHistForPairwiseLinksOutOfCluster', message);
    }
    static async GetGeometryTypeRatio(database) {
        let message = { database: database };
        return this.request('GetGeometryTypeRatio', message);
    }
    static async GetWinnerTable(database, sources) {
        let message = { database: database, sources: sources };
        return this.request('GetWinnerTable', message);
    }

    static async GetMostPoorlyConnectedToponyms(region, block, source, level, MunicipalitetID = null, StreetID = null, debug = false) {
        let message = { region: region, block: block, source: source, level: level };
        if (MunicipalitetID) {
            message.MunicipalitetID = MunicipalitetID;
        }
        if (StreetID) {
            message.StreetID = StreetID;
        }
        if (debug) {
            message.debug = 1;
        }
        return this.request('GetMostPoorlyConnectedToponyms', message);
    }

    static async createConnectorTask(region, blocks, version, selectedStages) {
        let message = { region: region, blocks: blocks, version: version, selectedStages: selectedStages };
        return this.request('createConnectorTask', message);
    }
    static async createHarvesterTask(region, harvester) {
        let message = { region: region, harvester: harvester };
        return this.request('createHarvesterTask', message);
    }
    static async getSourceGroups(database, source, groupField, namePart = null) {
        let message = { database: database, source: source, groupField: groupField };
        if (namePart) {
            message["namePart"] = namePart;
        }
        return this.request('getSourceGroups', message);
    }
    static async regionsUpdatesJournal() {
        let message = {};
        return this.request('regionsUpdatesJournal', message);
    }
    static async GetUncheckedPairs(source1, source2, database, block, count) {
        let message = { source1: source1, source2: source2, database: database, block: block, count: count };
        return this.request('GetUncheckedPairs', message);
    }
    static async SetPairDecisions(source1, source2, pairs) {
        let message = { source1: source1, source2: source2, pairs: pairs };
        return this.request('SetPairDecisions', message);
    }

    static async getMyDatasets(filter = null, limit = null, skip = null) {
        let message = {};
        if (filter) {
            message["filter"] = filter;
        }
        if (limit) {
            message["limit"] = limit;
        }
        if (skip) {
            message["skip"] = skip;
        }
        return this.request('getMyDatasets', message);
    }

    static async getToken(dataset) {
        let message = { dataset: dataset.dataset };
        if (dataset.database) {
            message.database = dataset.database;
        }
        return this.request('getToken', message);
    }

    static async uploadDataset(file, labelsInFirstRow, dataset = null) {
        const formData = new FormData();
        formData.append("data", file, file.name);

        let authKey = Hash.SHA1("uploadDataset" + file.name + ApiService.API_SECRET);
        let urlParams = '?clientId=' + encodeURIComponent(ApiService.API_CLIENT_ID) + '&authKey=' + encodeURIComponent(authKey) + '&method=' + encodeURIComponent("uploadDataset") + '&labelsInFirstRow=' + encodeURIComponent(labelsInFirstRow) + '&fileName=' + encodeURIComponent(file.name);
        if (dataset) {
            urlParams += '&dataset=' + encodeURIComponent(dataset);
        }
        if (ApiService.USERID) {
            urlParams += '&USERID=' + encodeURIComponent(ApiService.USERID);
        }

        let response = await fetch(ApiService.API_URL + urlParams, {
            credentials: 'same-origin',
            method: "POST",
            body: formData
        });
        if (!response.ok) throw Error(response.status);
        response = await response.json();
        return response;
    }

    static async updateDatasetMetadata(dataset, fields, datasetName) {
        let message = { dataset: dataset, fields: fields, datasetName: datasetName };
        return this.request('updateDatasetMetadata', message);
    }

    static async createLKGeometryTransformerTask(dataset, inputType, columnX, columnY, columnWKT, coordSystemProj4) {
        let message = { dataset: dataset, inputType: inputType };
        if (columnX) {
            message["columnX"] = columnX;
        }
        if (columnY) {
            message["columnY"] = columnY;
        }
        if (columnWKT) {
            message["columnWKT"] = columnWKT;
        }
        if (coordSystemProj4) {
            message["coordSystemProj4"] = coordSystemProj4;
        }
        return this.request('createLKGeometryTransformerTask', message);
    }

    static async createLKPublisherTask(dataset) {
        let message = { dataset: dataset };
        return this.request('createLKPublisherTask', message);
    }

    static async createLKConnectorTask(dataset, database, version, crossType, partsName, filter) {
        let message = { dataset: dataset, database: database, version: version, crossType: crossType, partsName: partsName, filter: filter };
        return this.request('createLKConnectorTask', message);
    }

    static async applyLKConnectorResults(dataset, treshold) {
        let message = { dataset: dataset, treshold: treshold };
        return this.request('applyLKConnectorResults', message);
    }

    static async createLKDecomposerTask(dataset, addressField) {
        let message = { dataset: dataset, addressField: addressField };
        return this.request('createLKDecomposerTask', message);
    }

    static async createLKNormaliserTask(dataset, fields) {
        let message = { dataset: dataset, fields: fields };
        return this.request('createLKNormaliserTask', message);
    }

    static async createLKExporterTask(datasetId, filter, sortBy, sortOrder, format) {
        let message = { datasetId: datasetId, filter: filter, format: format };
        if (!sortBy) {
            message["sortBy"] = sortBy;
        }
        if (!sortOrder) {
            message["sortOrder"] = sortOrder;
        }
        return this.request('createLKExporterTask', message);
    }

    static async deleteLKDataset(dataset) {
        let message = { dataset: dataset };
        return this.request('deleteLKDataset', message);
    }

    static async request(method, message, returnBlob) {
        if (message == null) message = {};
        message.method = method;
        message.deviceid = this.deviceId;
        if (ApiService.USERID) {
            message.USERID = ApiService.USERID;
        }
        message = JSON.stringify(message);
        let authKey = Hash.SHA1(message + ApiService.API_SECRET);
        let response = await fetch(ApiService.API_URL, {
            //credentials: "include",
            credentials: 'same-origin',
            //mode: "no-cors",
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: 'clientId=' + encodeURIComponent(ApiService.API_CLIENT_ID) + '&authKey=' + encodeURIComponent(authKey) + '&message=' + encodeURIComponent(message)
        });
        //console.log(response);
        if (!response.ok) throw Error(response.status);
        response = returnBlob ? await response.blob() : await response.json();
        // console.log('response =', response);
        return response;

    }

    static parseDate(dateString) {
        var reggie = /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/;
        var dateArray = reggie.exec(dateString);
        var dateObject = new Date(
            (+dateArray[1]),
            (+dateArray[2]) - 1, // Careful, month starts at 0!
            (+dateArray[3]),
            (+dateArray[4]),
            (+dateArray[5]),
            (+dateArray[6])
        );
        return dateObject;
    }

    static prettyDate(date) {
        var monthNames = [
            "января", "февраля", "марта",
            "апреля", "мая", "июня", "июля",
            "августа", "сентября", "октября",
            "ноября", "декабря"
        ];
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
    }

    static prettyDateTime(date, onlyDayAndMonthFlag = false) {
        var monthNames = [
            "января", "февраля", "марта",
            "апреля", "мая", "июня", "июля",
            "августа", "сентября", "октября",
            "ноября", "декабря"
        ];
        let minutes = "" + date.getMinutes();
        if (minutes.length < 2) {
            minutes = "0" + minutes;
        }
        if (onlyDayAndMonthFlag) return date.getDate() + " " + monthNames[date.getMonth()];
        else return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear() + " " + date.getHours() + ":" + minutes;
    }

    static calculateElapsedTime(startDate) {
        const currentDateTime = new Date();
        const elapsedMilliseconds = currentDateTime - startDate;
        const elapsedHours = elapsedMilliseconds / (1000 * 60 * 60);
        return {
            elapsedHours: Math.floor(elapsedHours),
            elapsedMilliseconds
        }
    }

    static colorWithOpacity(color, opacity) {
        let opacityInt = Math.round(255 * opacity);
        return color + opacityInt.toString(16);

    }

    static checkActiveProcess(dataset, processName) {
        if (dataset.runningTasks && dataset.runningTasks.length > 0) {
            for (let i = 0; i < dataset.runningTasks.length; i++) {
                if (dataset.runningTasks[i].performer === processName) {
                    return dataset.runningTasks[i];
                }
            }
        }
        return null;
    }


}

export default ApiService;